// import Vue from 'vue'

const state = {
}
const getters = {
}
const actions = {
  // 모바일 정보 요청
  getAppInfo: function ({ state }) {
    setTimeout(function () { if (state.axiosLoading) { state.axiosLoading = false } }, 8000)
    try {
      if (/Android/i.test(navigator.userAgent)) {
        window.android.getAppInfo()
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        window.webkit.messageHandlers.getAppInfo.postMessage('')
      }
    } catch (e) {
      console.log('app getInfos() call fail...')
    }
  },
  callCamera: function ({ state }) {
    setTimeout(function () { if (state.axiosLoading) { state.axiosLoading = false } }, 8000)
    try {
      if (/Android/i.test(navigator.userAgent)) {
        window.android.cameraOpen()
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        window.webkit.messageHandlers.cameraOpen.postMessage('')
      }
    } catch (e) {
      console.log('app callCamera() call fail...')
    }
  },
  setAppInfo: function ({ state }, [flag, id, pw]) {
    setTimeout(function () { if (state.axiosLoading) { state.axiosLoading = false } }, 8000)
    try {
      const param = {
        // idSaveFlag: flag,
        autoLoginFlag: flag,
        loginId: id,
        loginPw: pw
      }
      if (/Android/i.test(navigator.userAgent)) {
        window.android.setAppInfo(flag, id, pw)
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        window.webkit.messageHandlers.setAppInfo.postMessage(JSON.stringify(param))
      }
    } catch (e) {
      console.log('app setAppInfo() call fail...')
    }
  },
  callTel: function ({ state }, [type, data]) {
    setTimeout(function () { if (state.axiosLoading) { state.axiosLoading = false } }, 8000)
    try {
      const param = {
        type: type,
        data: data
      }
      if (/Android/i.test(navigator.userAgent)) {
        window.android.callTel(type, data)
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        window.webkit.messageHandlers.callTel.postMessage(JSON.stringify(param))
      }
    } catch (e) {
      console.log('app callTel() call fail...')
    }
  }
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
